/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Typography,
  Stack,
  Skeleton,
  Button,
  Box,
} from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';

const { OutlinedPlusIcon } = OutlinedIcons;

type SummaryCardProps = {
  title: string;
  isLoading: boolean;
  isEmpty: boolean;
  emptyMessage?: string;
  hasMore?: boolean;
  onAdd?: () => void;
  addDisabled?: boolean;
  extraActions?: React.ReactNode;
  onSeeMore?: () => void;
  headerContent?: React.ReactNode;
  children: React.ReactNode;
};

const SummaryCard = ({
  title,
  isLoading,
  isEmpty,
  emptyMessage = 'No items found.',
  hasMore = false,
  onAdd,
  addDisabled = false,
  extraActions,
  onSeeMore,
  headerContent,
  children,
}: SummaryCardProps) => (
  <Card>
    <CardHeader
      title={(
        <Box display="flex" alignItems="center" gap={2}>
          <Typography variant="h3">
            {title}
          </Typography>
          {headerContent}
        </Box>
      )}
      action={(
        <Stack direction="row" alignItems="center">
          {extraActions}
          {onAdd && (
            <IconButton disabled={addDisabled} onClick={onAdd}>
              <OutlinedPlusIcon color="primary" fontSize="small" />
            </IconButton>
          )}
        </Stack>
      )}
      sx={{ pb: 0 }}
    />
    <CardContent sx={{ overflow: 'hidden' }}>
      {isLoading ? (
        <Stack spacing={1}>
          <Skeleton variant="rounded" height={40} />
          <Skeleton variant="rounded" height={40} />
        </Stack>
      ) : !isEmpty ? (
        <Stack spacing={0.5}>
          {children}
          {hasMore && onSeeMore && (
            <Button
              variant="text"
              size="small"
              onClick={onSeeMore}
              sx={{ mt: 1, alignSelf: 'center' }}
            >
              See More
            </Button>
          )}
        </Stack>
      ) : (
        <Typography variant="body" color="common.black50">
          {emptyMessage}
        </Typography>
      )}
    </CardContent>
  </Card>
);

export default SummaryCard;
